// Disable for LBI microsites theme

    var headerInit = function () {
        if (!$('body').hasClass('thm-lbimicrosite')) {
        var timeDelay = 400;

        function collapseSubnav(subnav, nav) {
            subnav.slideUp(timeDelay);
            onSubnavCollapse(subnav, nav);
        }

        //adds required aria attributes and class on closing subnav
        function onSubnavCollapse(subnav, nav) {
            subnav.attr("aria-hidden", "true");
            nav.removeClass('is-active');
            nav.attr("aria-expanded", "false");
        }

        //adds required aria and class on opening subnav
        function onSubnavExpand(subnav, nav) {
            subnav.attr("aria-hidden", "false");
            nav.addClass('is-active');
            nav.attr("aria-expanded", "true");
        }

        //on clicking normal navigation link
            $("#menu a").on('click', function (e) {
            var subnavId = $(this).attr("data-subnav-id");
            var subnavActive = $('[data-id =' + subnavId + ']');

            //Adds subnav markup below nav link inside menu for small screens
            isMobileSubnavMarkupAdded =
                $(this).hasClass('is-mobileSubnavMarkupAdded');
            if (window.innerWidth < 992 && !isMobileSubnavMarkupAdded) {
                $(this).addClass('is-mobileSubnavMarkupAdded');
                if (subnavActive.length) {
                    var subnavActiveHTML = subnavActive.get(0).outerHTML;
                    $(this).after(subnavActiveHTML);
                }

                //Resetting If style display none from big screen, then on small screen
                //first click subnav is not shown 
                var subnavActiveElement = $(this).next();
                subnavActiveElement.attr('style', '');

                //update subnavActiveselector value
                subnavActive = $('[data-id =' + subnavId + ']');
                subnavActive.css("display", "none");
            }
            else if (window.innerWidth >= 992 && isMobileSubnavMarkupAdded) {
                $(this).removeClass('is-mobileSubnavMarkupAdded');
                $(this).nextAll().remove();
            }


            //open and closes subnav
            if (!$(this).hasClass('is-active')) {
                var subnavPreviousId, subnavActivePrevious,
                    isPreviousSubnavActive, isMobileSubnavMarkupAdded;

                //Checks whether previous nav link submenu active or not
                isPreviousSubnavActive =
                    $("#menu a").hasClass("is-active");

                if (isPreviousSubnavActive) {
                    navActivePrevious = $("#menu a.is-active");
                    subnavPreviousId = navActivePrevious.attr("data-subnav-id");
                    subnavActivePrevious = $('[data-id =' + subnavPreviousId + ']');
                    if (window.innerWidth >= 992) {
                        subnavActivePrevious.fadeOut(timeDelay);
                        subnavActive.delay(timeDelay).fadeIn(timeDelay);
                    }
                    else {
                        subnavActivePrevious.slideUp(timeDelay);
                        subnavActive.slideDown(timeDelay);
                    }
                    onSubnavCollapse(subnavActivePrevious, navActivePrevious);
                }
                else {
                    subnavActive.slideDown(timeDelay);
                }

                onSubnavExpand(subnavActive, $(this));
            }
            else {
                collapseSubnav(subnavActive, $(this));
            }
        });

        //On clicking close button inside sub navigation 
            $(".m-subnavClose").on('click', function () {
            var associatedSubnav = $(this).closest(".m-subnav");
            var subnavId = associatedSubnav.attr("data-id");
            var associatedNavlink = $("[data-subnav-id=" + subnavId + "]");
            collapseSubnav(associatedSubnav, associatedNavlink);
        });
        };
};


   